module.exports = __webpack_public_path__ + "img/course_class_empty.dc1be962.png";